import { render, staticRenderFns } from "./omsorderDetail.vue?vue&type=template&id=4d2c5ecb&scoped=true&"
import script from "./omsorderDetail.vue?vue&type=script&lang=js&"
export * from "./omsorderDetail.vue?vue&type=script&lang=js&"
import style0 from "./omsorderDetail.vue?vue&type=style&index=0&id=4d2c5ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c5ecb",
  null
  
)

export default component.exports